import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  height: 100px;
`;

export const StepText = styled.p`
  color: #646363;
  font-family: "Inter";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StepContainer = styled.div`
  display: flex;
  flex-direction: Column;
  width: 100px;
  align-items: center;
  gap: 8px;
`;

export const Circle = styled.div`
  height: 16px;
  width: 16px;
  border-radius: 8px;
  background-color: ${(props: any) => props.color};
  z-index: 999;
`;

export const Line = styled.div`
  display: flex;
  flex: 1;
  height: 3px;
  background-color: ${(props: any) => props.color};
  margin-left: -45px;
  margin-right: -45px;
  margin-top: 24px;
  z-index: 998;
`;
